import script from "./ProcessTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ProcessTemplate.vue?vue&type=style&index=0&id=96c31d70&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96c31d70"]])

export default __exports__